// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2l2zH","signatureButtonsRight":"ModalSign_signatureButtonsRight__3hFgc"};